import React from 'react';

/**
 * Insigrow logo: interlocking cyan / green / pink corner mark + wordmark.
 * `light` is for dark backgrounds. (Redrawn as SVG; swap in the official
 * logo file by replacing the <svg> below with an <img src=...> if you have one.)
 */
const InsigrowLogo = ({ light = false, className = '' }) => (
  <span className={`inline-flex items-center gap-3 ${className}`}>
    <svg viewBox="60 70 550 450" className="h-10 w-auto" aria-hidden="true">
      <polygon fill="#00AEEF" points="70,78 265,78 300,120 110,120 110,360 70,360" />
      <polygon fill="#4E9A51" points="130,145 315,145 355,195 170,195 170,430 130,430" />
      <polygon fill="#CC6CC0" points="190,220 375,220 410,268 230,268 230,500 190,500" />
      <polygon fill="#CC6CC0" points="440,80 478,80 478,362 295,362 260,320 440,320" />
      <polygon fill="#4E9A51" points="500,160 540,160 540,437 355,437 318,395 500,395" />
      <polygon fill="#00AEEF" points="562,225 598,225 598,510 405,510 370,462 562,462" />
    </svg>
    <span className={`text-2xl font-bold tracking-tight ${light ? 'text-white' : 'text-slate-900'}`}>
      Insigrow
    </span>
  </span>
);

export default InsigrowLogo;
